var React = require('react');

function LeftArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.5.2L19.3 3l-8.9 9 8.9 8.9-2.8 2.9L4.7 12z"}));
}

LeftArrow.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = LeftArrow;

LeftArrow.default = LeftArrow;
